import { render, staticRenderFns } from "./fincaBeneficiaryComponent.vue?vue&type=template&id=562f412c&"
import script from "./fincaBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./fincaBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports